import { MeshBasicMaterial, Vector3, PlaneGeometry, DoubleSide } from 'three';

export const CENTER = new Vector3();

export const SETTINGS = {
    opacity: 1,
    fov: 50,
    near: 1,
    far: 25000,
    factor: 20,
    camera2D: true,
    cameraPos: new Vector3(0, 0, 1500),
    lookAt: CENTER,
    controls: false,
    clearColor: '#02024c',
    clearColorAlpha: 0,
    noiseIntensity: 1.130,
    mouseX: 4.46,
    mouseY: 2.5,
    mouseLerp: .015,
    cameraLookAtLerp: .062,
    cameraLerp: .04,
    groupRotation: true,
    cameraRotation: false,
    controls: false
}

export const BASIC_MATERIAL = new MeshBasicMaterial({ color: 0x0000FF, side: DoubleSide });
export const PLANE_GEOMETRY = new PlaneGeometry();
